import { Button, FlexContainer } from '@act/storybook';
import { TextField, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import ReportsSurface from './ReportsSurface';

export interface ReportBuilderTemplateFooterProps {
  templateName: string;
  savingTemplate: boolean;
  onTemplateNameChange: (value: string) => void;
  onSaveTemplate: () => void;
}

/**
 * Footer row for saving the current report configuration as a reusable template.
 * @param props - Template name field and save handler.
 */
const ReportBuilderTemplateFooter = ({
  templateName,
  savingTemplate,
  onTemplateNameChange,
  onSaveTemplate,
}: ReportBuilderTemplateFooterProps) => (
  <FlexContainer
    direction="column"
    flexShrink={0}
    height="auto"
    overflowAllVisible={true}
  >
    <ReportsSurface>
      <FlexContainer
        direction="row"
        gap={1}
        alignItems="center"
        flexWrap={true}
        width="100%"
        height="auto"
        overflowAllVisible={true}
        flexShrink={0}
      >
        <TextField
          size="small"
          label="Save as template"
          value={templateName}
          onChange={event => onTemplateNameChange(event.target.value)}
        />
        <Button
          variant="outlined"
          disabled={savingTemplate}
          trackingName="reports-save-template"
          onClick={onSaveTemplate}
        >
          Save template
        </Button>
        <Typography variant="body2" color="text.secondary">
          or <Link to="/templates">view templates</Link>
        </Typography>
      </FlexContainer>
    </ReportsSurface>
  </FlexContainer>
);

export default ReportBuilderTemplateFooter;
